// MB.3 — fishing. PURE (ENG-1). The rod's cast/bite/reel timing and the catch
// table name; the host casts a bobber over water, waits for the bite tick, and
// on reel rolls FISHING_TABLE (data/loot/gameplay/fishing) for the reward.

/** Loot table a successful reel rolls. */
export const FISHING_TABLE = 'gameplay/fishing';

/** Bite window bounds (game ticks): Minecraft's 5–30 s at 20 tps. */
export const MIN_WAIT = 100;
export const MAX_WAIT = 600;

/**
 * Ticks from cast to bite: uniform in [MIN_WAIT, MAX_WAIT], each Lure level
 * shaving 5 s (100 gt), floored at 1 s so it never resolves instantly.
 */
export function biteDelay(roll01: number, lure = 0): number {
  const span = MAX_WAIT - MIN_WAIT;
  const base = MIN_WAIT + Math.floor(Math.max(0, Math.min(1, roll01)) * span);
  return Math.max(20, base - lure * 100);
}

export interface FishingState {
  /** The bobber is out (rod cast). */
  out: boolean;
  /** Absolute tick at which the fish bites. */
  biteAtTick: number;
}

/** Cast the rod: the bobber goes out and a bite is scheduled. */
export function cast(nowTick: number, roll01: number, lure = 0): FishingState {
  return { out: true, biteAtTick: nowTick + biteDelay(roll01, lure) };
}

/** Has the fish bitten yet? (host reels on a right-click while this is true). */
export function hasBite(state: FishingState | null, nowTick: number): boolean {
  return !!state && state.out && nowTick >= state.biteAtTick;
}

/**
 * Reel result: 'catch' if a fish had bitten, 'nothing' if reeled early. Either
 * way the bobber comes in (the caller clears the state).
 */
export function reel(state: FishingState | null, nowTick: number): 'catch' | 'nothing' {
  return hasBite(state, nowTick) ? 'catch' : 'nothing';
}
